import { SPECIAL_PHONE_NUMBERS } from "./Constants";

/** Longitudes del campo "NumTelefono" del anexo v4.4. */
export const PHONE_MIN_LENGTH = 8;
export const PHONE_MAX_LENGTH = 20;

/**
 * Deja el numero telefonico solo con digitos. El anexo define "NumTelefono" como
 * Integer, por lo que no admite guiones, espacios ni parentesis.
 */
export const normalizePhoneNumber = (raw?: string | null): string =>
    `${raw || ""}`.replace(/\D/g, "");

/**
 * Valida el numero telefonico segun el anexo v4.4: entre 8 y 20 digitos, salvo
 * los numeros telefonicos especiales (por ejemplo el 911), excepcion incorporada
 * en la bitacora del 22/04/2026.
 */
export const isValidPhoneNumber = (raw?: string | null): boolean => {
    const value = normalizePhoneNumber(raw);
    if (!value) {
        return false;
    }
    if (SPECIAL_PHONE_NUMBERS.has(value)) {
        return true;
    }
    return value.length >= PHONE_MIN_LENGTH && value.length <= PHONE_MAX_LENGTH;
};
